/**
 * Created by lihanying on 2017/6/30.
 */
import React from 'react'
import { Table, message, Button, DatePicker, Radio, Spin } from 'antd'
import { clickDownload, round } from '../../../util/index'
import ModalDetail from './modalDetail'
import moment from 'moment'
import { changeStringTime, changeToDecimal } from '../../../util'
const { RangePicker } = DatePicker

export default class extends React.Component {
  state = {
    visible: false,
    size: '4',
    loading: false,
  }

  componentDidMount() {
    this.props.fetchTimePeriod(this.state.size)
  }

  handleSizeChange = (e) => {
    this.setState({ size: e.target.value })
    this.props.fetchTimePeriod(e.target.value) //时间范围
  }

  onChange = (value, dateString) => {
    if (value.length > 0) {
      this.props.getPeriod({
        start_time: dateString[0],
        end_time: dateString[1],
      })
    } else {
      this.props.getPeriod({ start_time: null, end_time: null }) //清除
    }
  }

  onShowModal = (record) => {
    this.setState({ record: record, visible: true })
    const { period } = this.props
    this.props.fetchClubRepertoryDetail({
      commodity_id: record.id,
      start_time: period.start_time + ' 00:00',
      end_time:
        moment(period.end_time).add(1, 'days').format('YYYY-MM-DD') + ' 00:00',
    }) //详情
  }

  handleOk = () => {
    this.setState({ visible: false })
  }

  handleCancel = () => {
    this.setState({ visible: false })
  }

  onSubmit = () => {
    const { period } = this.props
    if (period.start_time) {
      const data = {
        start_time: period.start_time + ' 00:00',
        end_time:
          moment(period.end_time).add(1, 'days').format('YYYY-MM-DD') +
          ' 00:00',
      }
      this.setState({ loading: true })
      this.props.fetchRepertoryList(data).then((res) => {
        this.setState({ loading: false })
      })
    } else {
      message.info('请选择时间,再按显示按钮')
    }
  }

  render() {
    const { list, repertoryDetail, period } = this.props
    const { size } = this.state

    let reportName = sessionStorage.getItem('reportName')
    if (period && period.start_time && period.end_time) {
      reportName += `${changeStringTime(period.start_time)}-${changeStringTime(
        period.end_time
      )}`
    }

    const columns = [
      {
        title: '排序',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '商品名称',
        dataIndex: 'commodity_name',
        key: 'commodity_name',
      },
      {
        title: '单位',
        dataIndex: 'unit',
        key: 'unit',
      },
      {
        title: '期初库存数',
        dataIndex: 'qty_init',
        key: 'qty_init',
      },
      {
        title: '本期入库数',
        dataIndex: 'qty_income',
        key: 'qty_income',
      },
      {
        title: '本期出库数',
        dataIndex: 'sale_num',
        key: 'sale_num',
      },
      {
        title: '期末库存',
        dataIndex: 'qty_balance',
        key: 'qty_balance',
      },
      {
        title: '利润',
        dataIndex: 'benefits',
        key: 'benefits',
        sorter: (a, b) => a.benefits - b.benefits,
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '商品流水',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <Button type="primary" onClick={() => this.onShowModal(record)}>
              查询
            </Button>
          )
        },
      },
    ]

    const items =
      list.list &&
      list.list.map((item) => {
        item.benefits = round(item.benefit / 100, 2)
        return item
      })

    return (
      <div>
        <div style={{ marginBottom: '1rem' }}>
          <Radio.Group
            value={size}
            onChange={this.handleSizeChange}
            style={{ display: 'block', marginBottom: '1rem' }}
          >
            <Radio.Button value="1">昨日</Radio.Button>
            <Radio.Button value="2">今日</Radio.Button>
            <Radio.Button value="3">上月</Radio.Button>
            <Radio.Button value="4">本月</Radio.Button>
            <Radio.Button value="5">去年</Radio.Button>
            <Radio.Button value="6">今年</Radio.Button>
          </Radio.Group>
          <div>
            <span style={{ marginRight: '.5rem' }}>时间</span>
            <RangePicker
              format="YYYY-MM-DD"
              placeholder={['开始时间', '结束时间']}
              value={
                period.start_time
                  ? [
                      moment(`${period.start_time}`, 'YYYY-MM-DD'),
                      moment(`${period.end_time}`, 'YYYY-MM-DD'),
                    ]
                  : null
              }
              onChange={this.onChange}
            />
          </div>
        </div>
        <div
          style={{
            cursor: 'default',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: '1rem',
          }}
        >
          <Button type="primary" onClick={() => this.onSubmit()}>
            显示
          </Button>
          <Button style={{ backgroundColor: '#1AAD19' }}>
            <a
              id="test"
              href={clickDownload(columns, items)}
              download={`${reportName}.csv`}
              style={{ color: 'white' }}
            >
              导出
            </a>
          </Button>
        </div>

        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Table rowKey="id" bordered columns={columns} dataSource={items} />
        )}

        <ModalDetail
          {...this.state}
          list={repertoryDetail}
          handleOk={this.handleOk}
          handleCancel={this.handleCancel}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubRepertory/component/repertory.js